import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {AffairesService} from './affaires.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import {HeadersTool} from '../tools/headers';
import {saveAs} from 'file-saver';
import {Document} from '../affaires/affaires-list/affaires-list.component';

@Injectable({
  providedIn: 'root'
})
export class DocumentsService {

  constructor(
    private http: HttpClient,
    private affairesService: AffairesService,
    private snackBar: MatSnackBar,
  ) {}

  // TODO: add this method inside a service

  getLatestDocument(documents: Document[]) {
    if (!documents || documents.length === 0) return;

    return documents.reduce((latest, current) => {
      return new Date(current.createdAt) > new Date(latest.createdAt) ? current : latest;
    });
  }

  // TODO: add this method inside a service

  downloadLatestDocument(documents: Document[]): void {

    const document = this.getLatestDocument(documents);

    if(document)
      return this.download(document);

    this.snackBar.open('Aucun document trouvé', 'Fermer', { duration: 3000 });
  }

  download(document: Document) {
    const link = this.affairesService.getDownloadLink(document?.path);

    const headers = HeadersTool.getHeadersWithToken();

    this.snackBar.open('Téléchargement en cours...', 'Fermer', { duration: 3000 });

    this.http.get(link, { headers, responseType: 'blob' }).subscribe({
      next: (blob) => {
        if (blob.size === 0) {
          this.snackBar.open('Fichier invalide', 'Fermer', { duration: 3000 });
          return;
        }
        saveAs(blob, document?.productName);
        this.snackBar.open('Fichier téléchargé avec succès', 'Fermer', { duration: 3000 });
      },
      error: (err) => {
        console.error('Erreur de téléchargement', err);
        this.snackBar.open('Erreur lors du téléchargement du fichier', 'Fermer', { duration: 3000 });
      }
    });
  }
}
